import {
    STOREFRONT_VALUES_KEYS,
    STOREFRONT_VALUES_NAMESPACES,
} from "@/constants/storefront_values";
import { StorefrontValuesModule } from "@modules/storefront_values/StorefrontValuesModule";
import { singleton } from "tsyringe";

import ReviewsStorefrontValuesBrandingSchema from "../schemas/ReviewsStorefrontValuesBrandingSchema";
import ReviewsStorefrontValuesSettingsSchema from "../schemas/ReviewsStorefrontValuesSettingsSchema";

@singleton()
class ReviewsStorefrontValuesService {
    constructor(
        private readonly storefrontValuesModule: StorefrontValuesModule
    ) {}

    public selectReviewsSettings() {
        return this.storefrontValuesModule.exports.storefrontValuesManager.selectValue(
            {
                namespace: STOREFRONT_VALUES_NAMESPACES.REVIEWS_CRITICAL,
                key: STOREFRONT_VALUES_KEYS.REVIEWS_SETTINGS,
                schema: ReviewsStorefrontValuesSettingsSchema,
            }
        );
    }

    public selectReviewsBrandingOptions() {
        return this.storefrontValuesModule.exports.storefrontValuesManager.selectValue(
            {
                namespace: STOREFRONT_VALUES_NAMESPACES.REVIEWS_CRITICAL,
                key: STOREFRONT_VALUES_KEYS.REVIEWS_BRANDING,
                schema: ReviewsStorefrontValuesBrandingSchema,
            }
        );
    }
}

export default ReviewsStorefrontValuesService;
